module.exports = __webpack_public_path__ + "static/shadow_dancer-09ee94eba5dd9354da0eeab5aa6a0e10.png";